import { configureStore } from '@reduxjs/toolkit';
import todoSlice from 'slices/todoSlice';
import authSlice from 'slices/authSlice';
import disclaimerSlice from 'slices/disclaimerSlice';
import {
  TypedUseSelectorHook,
  useDispatch as useReduxDispatch,
  useSelector as useReduxSelector,
} from 'react-redux';

export const store = configureStore({
  reducer: {
    todo: todoSlice,
    auth: authSlice,
    disclaimer: disclaimerSlice,
  },
});

type AppDispatch = typeof store.dispatch;
type RootState = ReturnType<typeof store.getState>;

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useDispatch = () => useReduxDispatch<AppDispatch>();
export const useSelector: TypedUseSelectorHook<RootState> = useReduxSelector;

export default store;
